/* eslint-disable react/prop-types */
import React from "react";
import { Table } from "antd";

const Datatable = ({ props, columns, dataSource, loading, ...restProps }) => {
  return (
    <Table
      key={props}
      className="table datanew dataTable no-footer"
      columns={columns}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      loading={loading}
      {...restProps}
    />
  );
};

export default Datatable;
